import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 7457 15513"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g>
      <g id="_1974338667056">
        <path
          d="M5351 4056H2106c-254 0-460-206-460-460V460c0-254 206-460 460-460 255 0 461 206 461 460v2676h2323V460c0-254 206-460 461-460 254 0 460 206 460 460v3136c0 254-206 460-460 460zM4929 8911H2528V7172h2401z"
          className="fil0"
        />
        <path
          d="M6362 15513c-1706 0-3094-1430-3094-3187V8125h921v4201c0 1250 975 2267 2173 2267v920zM7457 3460c0 356-288 645-645 645H644c-355 0-644-289-644-645 0-355 289-644 644-644h6168c357 0 645 289 645 644z"
          className="fil0"
        />
        <path
          d="M3728 6084c-305 0-552-247-552-552s247-553 552-553 553 248 553 553-248 552-553 552zM727 3412v1513c0 1658 1344 3001 3001 3001 1658 0 3002-1343 3002-3001V3412H727z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
